module.exports = __webpack_public_path__ + "img/B.caaf28f4.svg";